import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, HostBinding, inject } from '@angular/core';
import { IconModule } from '@library/ui/atoms/icon/icon.module';
import { RadioButtonsModule } from '@library/ui/organisms/radio-buttons/radio-buttons.module';
import { PipesModule } from '@library/utils/pipes/pipes.module';
import { LocalStorageService } from '@library/utils/services/local-storage.service';
import { WeathermapFacade } from '@store/weathermap.facade';
import { PinType } from '@store/weathermap.store';
import { LayersService } from 'src/app/services/layers.service';
import { PIN_TYPE_CACHE_KEY } from 'src/app/weathermap.const';

@Component({
  selector: 'app-controls',
  imports: [
    RadioButtonsModule,
    IconModule,
    PipesModule,
  ],
  templateUrl: './controls.component.html',
  styleUrl: './controls.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      state('closed', style({
        transform: 'translateY(calc(100% + 30px))',
      })),
      state('opened', style({
        transform: 'translateY(0)',
      })),
      transition('closed <=> opened', animate('150ms ease-in-out')),
    ]),
  ],
})
export class ControlsComponent {
  private readonly weathermapFacade = inject(WeathermapFacade);
  private readonly localStorageService = inject(LocalStorageService);
  private readonly layerService = inject(LayersService);

  PinType = PinType;

  selectedType = this.weathermapFacade.selectedPintype;
  selectedStation = this.weathermapFacade.selectedStation;

  state: 'opened' | 'closed';
  @HostBinding('@slideInOut') get slideInOut(): string {
    return this.selectedStation() ? 'closed' : 'opened';
  }

  selectPinType(pinType: PinType): void {
    this.weathermapFacade.selectPinType(pinType);
    this.localStorageService.setItem(PIN_TYPE_CACHE_KEY, pinType);
    this.layerService.reloadLayers();
  }
}
